import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { AuthProvider } from './core/providers/AuthProvider';
import { ThemeProvider } from './core/providers/ThemeProvider';
import { PostsProvider } from './core/providers/PostsProvider';
import { PreferencesProvider } from './core/providers/PreferencesProvider';
import { useInitializeNotificationsCount } from './features/notifications/hooks/useNotifications';
import AppRoutes from './navigation/AppRoutes';
import './core/design-system/styles/global.css';
import { CategoriesProvider } from './core/providers/CategoriesProvider';

const NotificationsInitializer = () => {
  useInitializeNotificationsCount();
  return null;
};

function App() {
  return (
    <Router
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true
      }}
    >
      <AuthProvider>
        <PreferencesProvider>
          <ThemeProvider>
            <CategoriesProvider>
              <PostsProvider>
                <NotificationsInitializer />
                <AppRoutes />
              </PostsProvider>
            </CategoriesProvider>
          </ThemeProvider>
        </PreferencesProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;
